import Utils from '@/ecm/common/Utils';
import ContentTypeAlertAction from '@/ecm/models/contentType/alerts/ContentTypeAlertAction';

export default class ContentTypeAlert {
    constructor (dto) {
        this.uuid = Utils.object.getUUID();
        this.conditionStr = '';
        this.displayConditionStr = '';
        this.notifyByEmail = false;
        this.actions = [];
        this.roleTypes = [];
        this.triggerId = 1;

        if (dto) {
            Object.assign(this, dto, {
                actions: dto.actions.map(function (action) {
                    return new ContentTypeAlertAction(action);
                }),
                roleTypes: dto.roleTypeIDs.map(x => x + ''),
                triggerId: dto.contentTypeAlertTriggerID
            });
        }
    }

    toDto () {
        return {
            ConditionStr: this.conditionStr,
            NotifyByEmail: this.notifyByEmail,
            Actions: this.actions.map(function (action) { return action.toDto(); }),
            RoleTypeIDs: this.roleTypes.map(x => parseInt(x)),
            ContentTypeAlertTriggerID: this.triggerId,
        };
    }
}
